import McqCard from "../Questions/McqCard/McqCard";
import MmcqCard from "../Questions/MmcqCard/MmcqCard";
import TFCard from "../Questions/TFCard/TFCard";
import OneWord from "../Questions/OneWord/OneWord";
import FillBlankCard from "../Questions/FillBlankCard/FillBlankCard";

import QuestionMarks from "../QuestionMarks/QuestionMarks";
import AssertiveAndReasoning from "../Questions/OTQuestions/AssertiveReasoning";
import Descriptive from "../Questions/OTQuestions/Descriptive";

export default function Question({
  question,
  i,
  deleteQuestion,
  setQuestId,
  setSelQuest,
  page,
  getTotalMarks,
  reviewQuestion,
  setReviewQuestion,
  setChecked,
  setChaptersState,
  chaptersState,
  setTopicsState,
  topicsState,
  setCheckMarksState,
  checked,
  checkMarksState,
  totalMarks,
  setTotalMarks,
  questions,
  setQuestions,
  show = true, // optional prop to control marks visibility
}) {
  // Map each question type to its component
  const cardComponents = {
    mcq: McqCard,
    mmcq: MmcqCard,
    correctstatement: TFCard,
    oneword: OneWord,
    fillup: FillBlankCard,
    "assertion-reasoning":AssertiveAndReasoning,
    "descriptive":Descriptive
  };

  const CardComponent = cardComponents[question.questionType];

  if (!CardComponent) return null;

  return (
    <div className="onlineTest_Card" key={question._id || i}>
      <CardComponent
        isChecked
        question={question}
        index={i + 1}
        deleteQuestion={deleteQuestion}
        setQuestId={setQuestId}
        setSelQuest={setSelQuest}
        isMarks={true}
        page={page}
        getTotalMarks={getTotalMarks}
        reviewQuestion={reviewQuestion}
        setReviewQuestion={setReviewQuestion}
        setChecked={setChecked}
        setChaptersState={setChaptersState}
        chaptersState={chaptersState}
        setTopicsState={setTopicsState}
        topicsState={topicsState}
        setCheckMarksState={setCheckMarksState}
        isPraticeSession={false}
      />

      <div className="ques_marks">
        <span>Marks</span>
        <span
          style={{
            backgroundColor: "#FF7FA7",
            color: "#FF5087",
            fontSize: "18px",
          }}
        >
          <QuestionMarks
            id={question._id}
            reviewQuestion={reviewQuestion}
            setReviewQuestion={setReviewQuestion}
            getTotalMarks={getTotalMarks}
            checked={checked}
            mark={show ? question.marks || 0 : question.marks}
            setTotalMarks={setTotalMarks}
            totalMarks={totalMarks}
            checkMarksState={checkMarksState}
            setQuestions={setQuestions}
            questions={questions}
          />
        </span>
      </div>
    </div>
  );
}
